import styled, { css, keyframes } from "styled-components";
import {
  Content as RadixContent,
  Overlay as RadixOverlay,
  Title as RadixTitle,
  Description as RadixDescription,
} from "@radix-ui/react-alert-dialog";

const overlayShow = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const Overlay = styled(RadixOverlay)`
  background: ${(props) => props.theme.colors.overlay};
  position: fixed;
  z-index: 110;
  inset: 0;
  animation: ${overlayShow} ${(props) => props.theme.animation.delay.fast}
    cubic-bezier(0.16, 1, 0.3, 1);
`;

export const Content = styled(RadixContent)`
  background: ${(props) => props.theme.colors.background};
  border-radius: 5px;
  position: fixed;
  z-index: 111;
  left: 50%;
  top: 50%;
  width: 90vw;
  max-width: 500px;
  height: fit-content;
  display: flex;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  transform: translate(-50%, -50%);
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
`;

export const Title = styled(RadixTitle)`
  font-size: 28px;
  margin: 0 0 16px 0;
  text-align: center;
  color: ${(props) => props.theme.colors.scale[600]};
  ${(props) =>
    props.variant === "bar" &&
    css`
      width: 100%;
      margin: 0;
      padding: 18px 24px;
      font-size: 20px;
      line-height: 1.3;
      font-weight: 700;
      color: ${(props) => props.theme.colors.background};
    `}
`;
export const Description = styled(RadixDescription)`
  display: flex;
  flex-direction: column;
  margin: 0 0 16px 0;
  font-size: 14px;
  width: 100%;
  color: ${(props) => props.theme.colors.gray[700]};
  gap: 12px;
  span: {
    width: 100%;
  }
  .highlight {
    color: ${(props) => props.theme.colors.scale[600]};
  }
`;

export const ActionBox = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;
